import { FiSearch, FiUser, FiShoppingBag, FiInstagram, FiFacebook, FiYoutube } from "react-icons/fi";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import "./Header.css"
import {
  FiHeart,
  FiShuffle
} from "react-icons/fi";

import {
  FaInstagram,
  FaFacebookF,
  FaPinterestP,
  FaYoutube
} from "react-icons/fa";

function Header() {
  const [showSearch, setShowSearch] = useState(false);
  const [query, setQuery] = useState("");
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();
const [isScrolled, setIsScrolled] = useState(false);
const [showHeader, setShowHeader] = useState(true);
  const [openMenu, setOpenMenu] = useState(false);
  const [showLogoutPopup, setShowLogoutPopup] = useState(false);
const [isRefreshing, setIsRefreshing] = useState(false);
const [wishlistCount, setWishlistCount] = useState(0);
const [cartCount, setCartCount] = useState(0);
const [openUserDropdown, setOpenUserDropdown] = useState(false);
const [user, setUser] = useState(() => {
  try {
    return JSON.parse(localStorage.getItem("user"));
  } catch {
    return null;
  }
});
const location = useLocation();
const handleLogout = async () => {
  try {
    const userId = user?.id || user?.user_id;

    if (userId) {
      await fetch("https://aethearia.store/superadmin/api/logout", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          user_id: Number(userId),
        }),
      });
    }
  } catch (error) {
    console.error("Logout error:", error);
  } finally {
    localStorage.removeItem("user");
    localStorage.removeItem("token");

    setUser(null);
    navigate("/login");
  }
};
const getUserGuestPayload = () => {
  const storedUser = JSON.parse(localStorage.getItem("user") || "null");

  return storedUser?.id
    ? { user_id: storedUser.id, guest_id: "" }
    : { 
        user_id: "", 
        guest_id: localStorage.getItem("guest_id") || ""
      };
};
const fetchHeaderCounts = async () => {
  try {
    const payload = getUserGuestPayload();

    // Wishlist count
    const wishlistRes = await fetch(
      "https://aethearia.store/superadmin/api/wishlist-list",
      {
        method:"POST",
        headers:{
          "Content-Type":"application/json"
        },
        body:JSON.stringify(payload)
      }
    );

    const wishlistData = await wishlistRes.json();

    if(wishlistData.status){
      setWishlistCount(wishlistData.data.length);
    }else{
      setWishlistCount(0);
    }


    // Cart count
    const cartRes = await fetch(
      "https://aethearia.store/superadmin/api/cart-list",
      {
        method:"POST",
        headers:{
          "Content-Type":"application/json"
        },
        body:JSON.stringify(payload)
      }
    );

    const cartData = await cartRes.json();

    if(cartData.status){
      setCartCount(cartData.data.length);
    }else{
      setCartCount(0);
    }


  } catch(error){
    console.log("Header count error",error);
  }
};
useEffect(() => {
  fetchHeaderCounts();

  const handleHeaderCountUpdate = (event) => {
    const detail = event.detail || {};

    // instant update from page
    if (detail.wishlistCount !== undefined) {
      setWishlistCount(Number(detail.wishlistCount));
    }

    if (detail.cartCount !== undefined) {
      setCartCount(Number(detail.cartCount));
    }

    // if no count sent, fetch from API
    if (
      detail.wishlistCount === undefined &&
      detail.cartCount === undefined
    ) {
      fetchHeaderCounts();
      return;
    }

    // resync after API update completes
    setTimeout(() => {
      fetchHeaderCounts();
    }, 500);
  };

  window.addEventListener("cartWishlistUpdated", handleHeaderCountUpdate);

  return () => {
    window.removeEventListener("cartWishlistUpdated", handleHeaderCountUpdate);
  };
}, []);
// useEffect(() => {
//   const handleScroll = () => {
//     setIsScrolled(window.scrollY > 20);
//   };

//   handleScroll();

//   window.addEventListener("scroll", handleScroll);

//   return () => {
//     window.removeEventListener("scroll", handleScroll);
//   };
// }, []);

useEffect(() => {
  let lastScroll = 0;

  const handleScroll = () => {
    const currentScroll = window.scrollY;

    setIsScrolled(currentScroll > 20);

    if (currentScroll > lastScroll && currentScroll > 100) {
      // scrolling down
      setShowHeader(false);
    } else {
      // scrolling up
      setShowHeader(true);
    }

    lastScroll = currentScroll;
  };

  window.addEventListener("scroll", handleScroll);

  return () => {
    window.removeEventListener("scroll", handleScroll);
  };
}, []);
const handleMenuClick = (e, path) => {
  // Reload when the clicked menu page is already active
  if (location.pathname === path) {
    e.preventDefault();
    setIsRefreshing(true);

    setTimeout(() => {
      window.location.reload();
    }, 500);
  }
};
  const menuItems = [
    { name: "Our story", path: "/about" },
    { name: "Why aethearia", path: "/signature" },
    { name: "Find Your Flame", path: "/FindYourState" },
    { name: "Shop", path: "/shop-all" },
    { name: "Collab & Gifting", path: "/collection" },
    { name: "Take a Note", path: "/takeanote" }
  ];


useEffect(() => {
  const fetchProducts = async () => {
    try {
      const res = await fetch(
        "https://aethearia.store/superadmin/api/products-list"
      );

      const data = await res.json();

      if (data.status) {
        setProducts(data.data || []);
      }
    } catch (err) {
      console.error("Search products fetch error:", err);
    }
  };

  fetchProducts();
}, []);
const dynamicSuggestions = [
  ...new Set(
    products
      .map((item) => item.product_name)
      .filter(Boolean)
  ),
];
const filteredSuggestions = query
  ? dynamicSuggestions.filter((item) =>
      item.toLowerCase().includes(query.toLowerCase())
    )
  : dynamicSuggestions.slice(0, 6);

const filteredProducts = query
  ? products.filter((item) =>
      item.product_name?.toLowerCase().includes(query.toLowerCase()) 
      // item.sku?.toLowerCase().includes(query.toLowerCase())
    )
  : [];

  return (
    <>
      <style>{`
 .header-wrapper {
  position: fixed;
  top:0;
  left:0;
  width:100%;
  // background:#FFF8EE;
  z-index:1000;
  transition: transform 0.35s ease, background-color .35s ease, box-shadow .35s ease;

  }

.show-header{
  transform: translateY(0);
}

.hide-header{
  transform: translateY(-100%);
}
.header-wrapper.header-scrolled {
  background: #FFF8EE;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.08);
  border: 1px solid #ddd2c2 !important;
}

        /* TOP ROW */
        .top-row {
          display: grid;
          grid-template-columns: 1fr auto 1fr;
          align-items: center;
          padding: 12px 40px;
        }

        .logo {
          justify-self: center;
        }

        .logo img {
          height: 80px;
        }

        .top-right {
          justify-self: end;
          display: flex;
          gap: 18px;
          align-items: center;
        }

        .top-right a,
        .top-right button {
          color: #17130f;
          background: none;
          border: none;
          font-size: 18px;
          cursor: pointer;
                font-family: Assistant, sans-serif;

              text-decoration:none
        }

        /* BOTTOM ROW */
        .bottom-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 10px 40px;
          border-top: 1px solid rgba(255,255,255,0.1);
        }

        .menu-left {
          display: flex;
          gap: 35px;
        }

        .menu-left a {
          color: #17130f;
          text-decoration: none;
          font-size: 15px;
          letter-spacing: 1px;
          font-family: Assistant, sans-serif;

        }

        .search-box-inline {
            display: flex;
            align-items: center;
            background: #3e3c3cc4;
            padding: 8px 21px;
        }

        .search-box-inline input {
          background: transparent;
          border: none;
          outline: none;
          color: white;
          margin-left: 8px;
          width: 180px;
        }

        .search-box-inline svg {
          color: white;
        }

        /* SEARCH OVERLAY */
        .search-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0,0,0,0.4);
          display: flex;
          justify-content: center;
          align-items: flex-start;
          padding-top: 100px;
          z-index: 9999;
        }

        .search-box {
          background: #fff;
          width: 70%;
          padding: 20px;
        }

        .search-top {
          display: flex;
          justify-content: space-between;
          border-bottom: 1px solid #ddd;
          padding-bottom: 10px;
        }

        .search-top input {
          width: 90%;
          border: none;
          outline: none;
          font-size: 16px;
        }

        .search-content {
          display: flex;
          gap: 30px;
          padding: 20px 0;
        }

        .product-item {
          display: flex;
          gap: 10px;
          margin-bottom: 10px;
          cursor: pointer;
        }

        .product-item img {
          width: 50px;
          height: 50px;
          object-fit: cover;
        }
             .search-input::placeholder {
      color: white;
      opacity: 1;
    }
      @media(max-width:768px){

  /* TOP ROW FIX */
  .top-row{
    grid-template-columns: auto 1fr auto;
    padding: 12px 20px;
  }

  .logo{
    justify-self: center;
  }

  .logo img{
    height: 63px;
  }

  .top-right{
    gap: 10px;
  }

  .top-right span{
    display:none; /* hide text, keep clean */
  }

  /* HAMBURGER */
  .mobile-menu-btn{
    font-size: 28px;
    cursor: pointer;
  }

  /* HIDE DESKTOP MENU */
  .bottom-row{
    display:none;
  }

  /* MOBILE MENU PANEL */
.mobile-menu{
  position:fixed;
  top:0;
  left:0;
  width:80%;
  max-width:320px;
  height:100vh;
  background:#ece7dc;
  z-index:9999;
  padding:30px;
  display:flex;
  flex-direction:column;
  gap:22px;
  box-shadow:0 0 40px rgba(0,0,0,.2);
}

  .mobile-menu a{
    text-decoration:none;
    color:#4c144e;
    font-size:18px;
  }

  .close-btn{
    align-self:flex-end;
    font-size:20px;
    background:none;
    border:none;
    cursor:pointer;
  }

  /* SEARCH FIX */
  .search-box{
    width:90%;
  }

}
  /* HIDE by default (desktop) */
.mobile-menu-btn{
  display:none;
}

/* SHOW only on mobile */
@media(max-width:768px){
  .mobile-menu-btn{
    display:block;
  }
}
.top-strip {
  height: 40px;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  padding: 0 40px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  color: #4c144e;
}

.top-strip-left {
  min-height: 1px;
}

.top-center {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  font-size: 14px;
  letter-spacing: 1px;
  color: #4c144e;
}

.view-dashboard-link {
  color: #4c144e;
  text-decoration: underline;
  text-underline-offset: 4px;
  font-size: 14px;
}

.top-right-strip {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  font-size: 14px;
}

.top-right-strip a {
  color: #4c144e;
  text-decoration: none;
}

.logout-btn {
  background: transparent;
  border: none;
  color: #4c144e;
  cursor: pointer;
  font-size: 14px;
  font-family: Assistant, sans-serif;
}

.top-links a{
  text-decoration:none;
  color:#4c144e;
}

.main-header{
  display:flex;
  align-items:flex-end;   /* pushes menu down */
  padding:18px 36px;
  width:100%;
}


.logo{
  flex:0 0 auto;
}

.logo img{
  height:80px;
}


/* center menu */
.menu-center{
  position:absolute;
  left:53%;
  transform:translateX(-50%);
  bottom:22px;   /* move menu downward */
  display:flex;
  gap:35px;
  align-items:center;
}


.menu-center a{
  text-decoration:none;
  color:#4c144e;
  font-size:15px;
  white-space:nowrap;
}


/* icons right */
.header-icons{
  margin-left:auto;
  display:flex;
  gap:22px;
  align-items:center;
}

.menu-center{
  display:flex;
  justify-content:center;
  gap:35px;
}

.menu-center a {
text-decoration: none;
color: #4c144e;
font-size: 15px;
text-transform: capitalize;
}
.header-icons{
  display:flex;
  justify-content:flex-end;
  gap:18px;
}

.header-icons a,
.header-icons button{
  background:none;
  border:none;
  color:#4c144e;
  font-size:20px;
  cursor:pointer;
}
  .social-icons {
  color:#4c144e;
font-size: 20px;
  display:flex;
  gap:10px;
}
  @media (max-width: 768px) {

  .top-strip{
    display:none;
  }

  .main-header{
    display:grid;
    grid-template-columns:40px 1fr auto;
    padding:12px 15px;
    align-items:center;
    gap:10px;
    
  }

  .logo{
    text-align:center;
  }

  .logo img{
    height:65px;
  }

  .menu-center{
    display:none;
  }

  .header-icons{
    gap:12px;
    margin-right:20px
  }

  .header-icons svg{
    font-size:20px;
  }

  .mobile-menu-btn{
    display:flex;
    align-items:center;
    justify-content:center;
    font-size:26px;
    cursor:pointer;
    margin-bottom: -16px;
  }

  .header-icons a[href="/dashboard"]{
    display:none;
  }
}
  .mobile-auth{
  display:none;
}

@media(max-width:768px){

  .mobile-auth{
    display:flex;
    justify-content:center;
    gap:10px;
    padding:8px 0 12px;
    font-size:14px;
    border-top:1px solid #4c144e;
  }

  .mobile-auth a{
    color:#4c144e;
    text-decoration:none;
  }
  
}
  .menu-center a.active-menu,
.mobile-menu a.active-menu {
  font-weight: 700;
  color: #4c144e;
  // position: relative;
}

.menu-center a.active-menu::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -6px;
  width: 100%;
  height: 2px;
  background: #4c144e;
  border-radius: 10px;
}

.menu-center a {
  font-weight: 400;
  // transition: all 0.25s ease;
}

// .menu-center a:hover {
//   font-weight: 600;
// }

@keyframes pageRefreshFade {
  0% {
    opacity: 0.65;
    transform: translateY(8px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

body.page-refresh-anim #root {
  animation: pageRefreshFade 0.5s ease;
}
  .menu-center a.active-menu,
.mobile-menu a.active-menu {
  font-weight: 700;
  color: #4c144e;
  position: relative;
}

.menu-center a.active-menu::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -6px;
  width: 100%;
  height: 2px;
  background: #4c144e;
  border-radius: 10px;
}

.menu-center a {
  font-weight: 400;
  // transition: color 0.25s ease;
}

// .menu-center a:hover {
//   color: #4c144e;
// }
  .refresh-loader {
  position: fixed;
  inset: 0;
  background: rgba(255, 248, 238, 0.92);
  z-index: 99999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loader-circle {
  width: 54px;
  height: 54px;
  border: 4px solid rgba(76, 20, 78, 0.2);
  border-top: 4px solid #4c144e;
  border-radius: 50%;
  animation: spinLoader 0.8s linear infinite;
}

@keyframes spinLoader {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
  .mobile-auth {
  display: none;
}

@media (max-width: 768px) {
  .top-strip {
    display: none;
  }

  .mobile-auth {
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: center;
    padding: 8px 15px 12px;
    font-size: 14px;
    border-top: 1px solid #4c144e;
    color: #4c144e;
  }

  .mobile-welcome {
    text-align: center;
    justify-self: center;
  }

  .mobile-login-links {
    grid-column: 1 / -1;
    display: flex;
    justify-content: center;
    gap: 10px;
  }

  .mobile-login-links a {
    color: #4c144e;
    text-decoration: none;
  }
        .header-icons {
        gap: 12px;
        margin-right: 20px;
        margin-bottom: -19px;
    }
        .cross-button{
        background:none;
        border:none
        }
}
      `}</style>
{isRefreshing && (
  <div className="refresh-loader">
    <div className="loader-circle"></div>
  </div>
)}
<header 
 className={`header-wrapper 
 ${isScrolled ? "header-scrolled" : ""} 
 ${showHeader ? "show-header" : "hide-header"}`}
>
        {/* TOP ROW */}
{/* <div className="top-strip">
  <div className="top-strip-left"></div>

  <div className="top-center">
    {user && (
      <>
        <span>
          Welcome, {user.fname || user.name || "User"}
        </span>

        <Link to="/dashboard" className="view-dashboard-link">
           <FiUser /> View Dashboard
        </Link>
      </>
    )}
  </div>

  <div className="top-right-strip">
    {user ? (
     <button
  className="logout-btn"
  onClick={() => setShowLogoutPopup(true)}
>
  Logout
</button>
    ) : (
      <>
        <Link to="/login">Login</Link>
        <span>|</span>
        <Link to="/register">Register</Link>
      </>
    )}
  </div>
</div> */}
{/* <div className="mobile-auth">
  {user ? (
    <>
      <span className="mobile-welcome">
        Welcome, {user.fname || user.name || "User"}
      </span>

      <button
  className="logout-btn"
  onClick={() => setShowLogoutPopup(true)}
>
  Logout
</button>
    </>
  ) : (
    <div className="mobile-login-links">
      <Link to="/login">Login</Link>
      <span>|</span>
      <Link to="/register">Register</Link>
    </div>
  )}
</div> */}
        {/* BOTTOM ROW */}
    <div className="main-header">

  <div
    className="mobile-menu-btn"
    onClick={() => setOpenMenu(true)}
  >
    ☰
  </div>

  <div className="logo">
    <Link to="/" onClick={(e) => handleMenuClick(e, "/")}>
      <img
        src={process.env.PUBLIC_URL + "/aethearia-img/aethearia-logo-new.png"}
        alt="logo"
      />
    </Link>
  </div>

<div className="menu-center">
  {menuItems.map((item, i) => (
    <NavLink
      key={i}
      to={item.path}
      end={item.path === "/"}
      className={({ isActive }) => (isActive ? "active-menu" : "")}
      onClick={(e) => handleMenuClick(e, item.path)}
    >
      {item.name}
    </NavLink>
  ))}
</div>

  <div className="header-icons">

    <button style={{marginBottom: '-2px'}} onClick={() => setShowSearch(true)}>
      <FiSearch />
    </button>

    <Link to="/wishlist" className="header-count-icon">
  <FiHeart />

  {wishlistCount > 0 && (
    <span className="count-badge">
      {wishlistCount}
    </span>
  )}
</Link>
  <Link to="/cart" className="header-count-icon">
  <FiShoppingBag />

  {cartCount > 0 && (
    <span className="count-badge">
      {cartCount}
    </span>
  )}
</Link>

    {/* <Link to="/dashboard">
      <FiUser />
    </Link> */}

<div className="user-menu">
  <button type="button" className="user-menu-btn">
    <FiUser />
  </button>

  <div className="user-dropdown">
    {user ? (
      <>
        {/* <Link to="/dashboard">Dashboard</Link> */}
         <button
  type="button"
  onClick={() => navigate("/dashboard")}
  style={{fontSize:'14px'}}
>
  Dashboard
</button>
        <button
          type="button"
          onClick={() => setShowLogoutPopup(true)}
          style={{fontSize:'14px'}}
        >
          Logout
        </button>
      </>
    ) : (
      <>
        <Link to="/login" style={{fontSize:'14px'}}>Login</Link>
        <Link to="/register" style={{fontSize:'14px'}}>Register</Link>
      </>
    )}
  </div>
</div>

 
    {/* <Link to="/compare">
     <FiShuffle />
    </Link> */}

  </div>

</div>

      </header>
      {openMenu && (
        <div className="mobile-menu">
          <button className="close-btn" onClick={() => setOpenMenu(false)}>✕</button>

       {menuItems.map((item, i) => (
        <NavLink
          key={i}
          to={item.path}
          end={item.path === "/"}
          className={({ isActive }) => (isActive ? "active-menu" : "")}
          onClick={(e) => {
            handleMenuClick(e, item.path);
            setOpenMenu(false);
          }}
        >
          {item.name}
        </NavLink>
      ))}
        </div>
      )}
      {/* SEARCH OVERLAY */}
      {showSearch && (
        <div className="search-overlay" onClick={() => setShowSearch(false)}>
          <div className="search-box" onClick={(e) => e.stopPropagation()}>

            <div className="search-top">
              <input
                type="text"
                placeholder="Search products..."
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    navigate(`/shop-all?search=${encodeURIComponent(query)}`);
                    setShowSearch(false);
                  }
                }}
              />
              <button className="cross-button" onClick={() => setShowSearch(false)}>✕</button>
            </div>

            <div className="search-content">

              <div>
              {filteredSuggestions.slice(0, 8).map((item, i) => (
                  <p
                    key={i}
                    className="suggestion-item"
                    onClick={() => {
                      navigate(`/shop-all?search=${encodeURIComponent(item)}`);
                      setShowSearch(false);
                      setQuery("");
                    }}
                  >
                    {item}
                  </p>
                ))}
              </div>

              <div>
           {filteredProducts.slice(0, 6).map((item) => (
              <div
                key={item.id}
                className="product-item"
                onClick={() => {
                  navigate(`/product/${item.product_slug}`);
                  setShowSearch(false);
                  setQuery("");
                }}
              >
                <img
                  src={`https://aethearia.store/superadmin/uploads/products/Hero/${item.hero_image}`}
                  alt={item.product_name}
                />

                <div>
                  <span>{item.product_name}</span>
                  <small>
                    ₹
                    {Number(item.min_offer_price) > 0
                      ? item.min_offer_price
                      : item.min_price}
                  </small>
                </div>
              </div>
            ))}
              </div>

            </div>

          </div>
        </div>
      )}
      {showLogoutPopup && (
  <div className="logout-popup-overlay">
    <div className="logout-popup">
      <h3>Are you sure?</h3>

      <p>Do you really want to logout from your account?</p>

      <div className="logout-popup-actions">
        <button
          className="cancel-logout-btn"
          onClick={() => setShowLogoutPopup(false)}
        >
          Cancel
        </button>

        <button
          className="confirm-logout-btn"
          onClick={handleLogout}
        >
          Yes, Logout
        </button>
      </div>
    </div>
  </div>
)}
    </>
  );
}

export default Header;